import { useState } from 'react';

import { CustomerFacility, ProductSize } from '../../../../../api-client';

export interface IProductForm {
    deliveryDate?: any;
    facility?: CustomerFacility;
    limitedEditionCode?: string;
    sizes: ProductSize[];
    subTotal: number;
}

const defaultValues = {
    sizes: [],
    subTotal: 0
}

export const useProductForm = () => {
    const [formValues, setFormValues] = useState<IProductForm>(defaultValues);

    const handleInitialize = (values: IProductForm) => setFormValues(values);

    const handleChange = (name: string, value: any) => {
        setFormValues({
            ...formValues,
            [name]: value
        });
    }

    const handleChangeMultiple = (multipleValues: any) => {
        setFormValues({
            ...formValues,
            ...multipleValues
        });
    }

    return {
        handleInitialize,
        handleChange,
        handleChangeMultiple,
        formValues
    };
}